function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.821.389L5.5 4.71 1.179.39",
  stroke: "#5C5D66",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgChevronDown = function SvgChevronDown(props) {
  return React.createElement("svg", _extends({
    width: 11,
    height: 5,
    viewBox: "0 0 11 5"
  }, props), _ref);
};

export default SvgChevronDown;